import React from 'react';
import FormField, {Props} from '../../../../src/components/Form/FormField';
import {IOrderModel} from '../../../../src/@interfaces/models/Order/IOrderModel';
import {IEmptyModel} from '../../../../src/@interfaces/IEmptyModel';
import {NestedListWidgetProps} from '../../../../src/@types/components/Form';
import {NestedListFieldWidget} from '../../../../src/components/Form/widgets';
import {ControlledListProps} from '../../../../src/@types/components/ControlledList';
import ControlledList from '../../../../src/components/ControlledList/ControlledList';
import {MessageColumn} from './MessageColumn';
import {IOrderLogModel} from '../../../../src/@interfaces/models/Order/IOrderLogModel';

const listContextValue: ControlledListProps<IOrderLogModel>['listContextValues'] = {
    getCustomColumnComponent(config) {
        if (config.name === 'message') {
            return MessageColumn;
        }

        return null;
    }
};

function List<Model extends IEmptyModel>(props: ControlledListProps<Model>) {
    return <ControlledList
            {...props}
            records={props.records.sort((a, b) => +(b?.id ?? 0) - +(a?.id ?? 0))}
            listContextValues={listContextValue}
    />;
}

function Adapter<Model extends IEmptyModel>(props: NestedListWidgetProps<Model>) {
    return <NestedListFieldWidget<Model> {...props} controlledListComponent={List}/>;
}

export default function OrderLogsField<Model extends IOrderModel = IOrderModel>(props: Props<Model>) {
    return <FormField {...props} withoutLayout={true} fieldElement={Adapter}/>;
}
